import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

export interface Address {
    street: string
    unit: string
    city: string
    postalCode: string
    state: string
    country: string
}

export interface AddressEditorProps {
    address: Address | null
    onAddressChange: (address: Address, isValid: boolean) => void
}

export function AddressEditorComponent({ address, onAddressChange }: AddressEditorProps) {
    const { t } = useTranslation();

    const [street, setStreet] = React.useState<string>(address?.street ?? "")
    const [unit, setUnit] = React.useState<string>(address?.unit ?? "")
    const [postalCode, setPostalCode] = React.useState<string>(address?.postalCode ?? "")
    const [city, setCity] = React.useState<string>(address?.city ?? "")
    const [state, setState] = React.useState<string>(address?.state ?? "")
    const [country, setCountry] = React.useState<string>(address?.country ?? "")

    React.useEffect(() => {
        onAddressChange({
            street: street,
            unit: unit,
            city: city,
            postalCode: postalCode,
            state: state,
            country: country
        }, true);
    }, [street, unit, city, postalCode, state, country])

    return (
        <>
            <div className="form-floating mb-3">
                <input className="form-control" id="address" placeholder={t('address')} value={street} onChange={e => setStreet(e.target.value) } />
                <label htmlFor="address">{t('address')}</label>
            </div>
            <div className="form-floating mb-3">
                <input className="form-control" id="unit" placeholder={t('unit')} value={unit} onChange={(e) => setUnit(e.target.value)} />
                <label htmlFor="unit">{t('unit')}</label>
            </div>
            <div className="row g-2">
                <div className="col-lg-6">
                    <div className="form-floating mb-3">
                        <input className="form-control" id="city" placeholder={t('city')} value={city} onChange={(e) => setCity(e.target.value)} />
                        <label htmlFor="city">{t('city')}</label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-floating mb-3">
                        <input className="form-control" id="postalCode" placeholder={t('postalCode')} value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
                        <label htmlFor="postalCode">{t('postalCode')}</label>
                    </div>
                </div>
            </div>
            <div className="row g-2">
                <div className="col-lg-6">
                    <div className="form-floating mb-3">
                        <CountryDropdown defaultOptionLabel={t('selectCountry')} whitelist={['US', 'CA', 'SG', 'AU', 'JP', 'KR', 'ID', 'MY', 'TH', 'VN', 'PH', 'NZ', 'TW', 'BB']}
                            classes="form-select" value={country} onChange={(e) => setCountry(e)} />
                        <label htmlFor="country">{t('country')}</label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-floating mb-3">
                        <RegionDropdown defaultOptionLabel={t('selectRegion')} classes="form-select" value={state} country={country} onChange={e => setState(e)} />
                        <label htmlFor="state">{t('region')}</label>
                    </div>
                </div>
            </div>
        </>
    )
}